// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "notifications-worker" + "." + "95dfcc73" + ".chunk.js";
};